var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketPathologistIconFaQsTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    enableBackground: "new 0 0 700 700",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9076B6",
    d: "M478.04,153.47l-234.55,18.97c-54.78,4.43-96.98,50.18-96.98,105.14v100.44 c0,52.77,39,97.43,91.29,104.53l112.5,15.28c5.81,15.77,11.51,45.16-6.6,79.6c-3.38,6.43-10.91,14.52-5.03,17.5 c4.44,2.25,21.4,0.83,26.01-2.14c35.84-23.11,36.49-45.8,41.88-87.31l65.14,8.85c63.14,8.57,119.41-40.36,119.68-104.08 l0.64-151.17C592.29,197.27,539.63,148.48,478.04,153.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDABD3",
    d: "M461.42,153.47l-222.79,18.97c-52.03,4.43-92.12,50.18-92.12,105.14v100.44 c0,52.77,37.04,97.43,86.71,104.53l98.55,14.09c5.95,15.45,12.42,45.46-6.16,80.78c-5.94,11.3,10.26,22.27,20.98,15.36 c36.04-23.24,36.5-46.05,41.97-88.02l66.83,9.55c59.97,8.57,113.42-40.36,113.68-104.08l0.61-151.17 C569.94,197.27,519.92,148.48,461.42,153.47z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9076B6",
    d: "M297.43,269.57c1.96,5.43-5.78,11.06-0.44,13.24c0.81,0.33,12.17-0.36,14.35-0.36 c4.88-0.01,10.15,0.01,14.65-7.28c10.64-17.23-5.07-55.22,34.45-55.73c39.52-0.51,48.85,39.32,27.07,62.63 c-21.79,23.31-81.06,15.56-78.02,68.25c0.88,15.18-6.11,31.79-1.01,38.47c2.64,3.46,17.76,3.4,21.17,1.91 c10.9-4.76,21.35-10.5,19.14-44.59c-1.82-28.1,91.41-7.12,91.41-75.52s-36.19-79.52-74.69-79.52 C328.23,191.08,277.16,213.41,297.43,269.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F459B",
    d: "M280.6,269.57c1.96,5.43,6.06,9.88,11.4,12.07c5.26,2.15,11.84,2.15,17.16-6.46 c10.64-17.23-5.07-55.22,34.45-55.73c39.52-0.51,48.85,39.32,27.07,62.63c-21.79,23.31-81.06,15.56-78.02,68.25 s43.23,56.39,39.3-4.21c-1.82-28.1,91.41-7.12,91.41-75.52s-36.19-79.52-74.69-79.52C311.39,191.08,260.32,213.41,280.6,269.57z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9076B6",
    cx: 332.84,
    cy: 431.79,
    rx: 30.77,
    ry: 22.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5F459B",
    cx: 320.94,
    cy: 431.79,
    rx: 30.77,
    ry: 22.63
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketPathologistIconFaQsTransparent);
export default __webpack_public_path__ + "static/media/Pocket Pathologist-Icon_FAQs-transparent.40c7f0b8493e6eb1f4155e37f0006a4a.svg";
export { ForwardRef as ReactComponent };